import { html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { when } from "lit/directives/when.js";
import { StateController } from "../state";
import { CardQueryGenerator } from "../functions/card-query-generator";
import { setPageMetadata } from "../functions/set-page-metadata";
import { CanOpenPackageElement } from "../can-open-package.element";
import { type IndexedParams } from "@vaadin/router";
import { appRouter } from "../router";

/**
 * Defines the list page container
 * Used for:
 *  - search
 *  - category
 *  - all/n
 *  - awards/n
 *  - hall-of-fame
 */
@customElement("umb-market-list")
export class UmbMarketList extends CanOpenPackageElement {
  #stateController: StateController;

  @state()
  private _query!: object;

  @property({ type: Object })
  params: IndexedParams = {};

  constructor() {
    super();
    this.#stateController = new StateController(this);
  }

  connectedCallback() {
    super.connectedCallback();
    setPageMetadata();

    window.addEventListener("filter-changed", this.#handleFilterChange);
    window.addEventListener("filter-cleared", this.#handleFilterChange);

    this.#stateController.set(this.params, appRouter!.location);

    if (this.#stateController.state.categories?.length) {
      this._query = { ...CardQueryGenerator() };
    }
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();
    window.removeEventListener("filter-changed", this.#handleFilterChange);
    window.removeEventListener("filter-cleared", this.#handleFilterChange);
  }

  #handleFilterChange = () => {
    this._query = { ...CardQueryGenerator() };
  };

  render() {
    return html`
      <umb-market-page-title> </umb-market-page-title>
      <umb-market-filter-panel></umb-market-filter-panel>

      ${when(
        this._query,
        () => html` <umb-market-card-deck
          ?static=${true}
          .showDeckHeader=${false}
          .query=${this._query}
        ></umb-market-card-deck>`
      )}
    `;
  }
}
